// deps
import React from "react";

// helpers
import { getListItemProps } from "@dineout-payment-success-ui/helpers/index";
import { getBridgeSdk, getDownstreamHostsValue } from "@swiggy-private/checkout-core";
import { NavigationTypes } from "@swiggy-private/native-bridge";

// types
import { CTA_TYPE, ITicketAttributes } from "@dineout-payment-success-ui/interfaces";

// constants
import { LIST_TITLES, MY_COUPONS_NATIVE_PAGE_DEEPLINK } from "@dineout-payment-success-ui/constants";

// styles
import { ListTextWrapper } from "../components/dineout-payment-success/styles";
import { isEmpty } from "@swiggy-private/js-utils";

export const getPurchaseCouponListItems = (
    ticketAttributes: ITicketAttributes,
    onFaqClick: (title?: string, idx?: number) => void,
) => {
    const listItems = [];

    if (!isEmpty(ticketAttributes?.thingsToRemember)) {
        const idx = listItems.length + 1;
        const title = ticketAttributes?.noteText;

        listItems.push({
            id: idx,
            ...getListItemProps(title, () => onFaqClick(title, idx)),
            children: (
                <ListTextWrapper variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                    <ol>
                        {ticketAttributes.thingsToRemember.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ol>
                </ListTextWrapper>
            ),
        });
    }

    if (!isEmpty(ticketAttributes?.tnc)) {
        const idx = listItems.length + 1;

        listItems.push({
            id: idx,
            ...getListItemProps(LIST_TITLES.COUPON_TNC, () => onFaqClick(LIST_TITLES.COUPON_TNC, idx)),
            children: (
                <ListTextWrapper
                    variant="V2.body3.neutral.regular"
                    color="text_Med_Emphasis"
                    dangerouslySetInnerHTML={{ __html: ticketAttributes.tnc }}
                />
            ),
        });
    }

    return listItems;
};

export const redirectToMyCouponsPage = () => {
    try {
        const myVouchersDeeplink = getDownstreamHostsValue("STEAL_STORE_MY_VOUCHERS_URL");
        if (!myVouchersDeeplink) {
            return;
        }

        getBridgeSdk().navigateToScreen({
            type: NavigationTypes.DEEPLINK,
            link: `swiggy://webviewV2?webview_url=${encodeURIComponent(myVouchersDeeplink)}`,
            params: {
                shouldCloseWebview: true,
            },
        }).catch(() => undefined);
    } catch {
        // noop
    }
};

export const redirectToNativeMyCouponsPage = () => {
    try {
        getBridgeSdk().navigateToScreen({
            type: NavigationTypes.DEEPLINK,
            link: `swiggydiners://${MY_COUPONS_NATIVE_PAGE_DEEPLINK}`,
        }).catch(() => undefined);
    } catch {
        // noop
    }
};

export const navigateToVoucherEntity = (link?: string, ctaType?: CTA_TYPE) => {
    if (isEmpty(link)) {
        return;
    }

    const bridgeSdk = getBridgeSdk();

    try {
        switch (ctaType) {
            case CTA_TYPE.TYPE_DEEP_LINK:
                return bridgeSdk
                    .navigateToScreen({
                        type: NavigationTypes.DEEPLINK,
                        link,
                        params: {
                            shouldCloseWebview: false,
                        },
                    })
                    .catch(() => undefined);

            case CTA_TYPE.TYPE_INTERNAL_LINK:
                return bridgeSdk
                    .webNavigate({
                        url: link,
                        openAsExternal: true,
                        openAsExternalWithBridgeSupport: false,
                        showBack: true,
                        showLoader: true,
                        callbackUrl: window.location.href,
                        title: "",
                    })
                    .catch(() => undefined);

            case CTA_TYPE.TYPE_EXTERNAL_LINK:
                return bridgeSdk.launchBrowser({ url: link }).catch(() => undefined);

            case CTA_TYPE.TYPE_INVALID:
            default:
                return;
        }
    } catch {
        // noop
    }
};
